export const getConfigParam = (key: string, def?: string) => {
  if (key in process.env) {
    return `${process.env[key]}`
  }

  // This code is not going to blow up at runtime because it's so defensive but
  // TS still complains about it.
  // @ts-ignore
  if (typeof window !== 'undefined' && typeof window.CONFIG !== 'undefined') {
    // @ts-ignore
    if (key in window.CONFIG) {
      // @ts-ignore
      return `${window.CONFIG[key]}`
    }
  }

  return def
}

export const getAppEnv = () => {
  const appEnv = getConfigParam('REACT_APP_APP_ENV', 'development') as string
  const isNotProduction = [
    'development',
    'review',
    'staging',
    'integration',
    'test',
  ].includes(appEnv)
  const isProduction = !isNotProduction

  return { appEnv, isProduction }
}
